import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useState } from 'react';

const FreeLicense = () => {
  const [email, setEmail] = useState('');

  const grantAccess = async () => {
    try {
      await setDoc(doc(db, 'users', email), {
        email,
        accessTier: 'free',
        createdAt: new Date()
      });
      alert(`✅ Free access granted to ${email}`);
    } catch (err) {
      console.error('Grant error:', err);
      alert('❌ Failed to grant access');
    }
  };

  return (
    <div style={{ padding: '40px' }}>
      <h2>🆓 Grant Free License Access</h2>
      <input
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="User email"
        style={{ padding: '12px', width: '300px', marginRight: '10px' }}
      />
      <button onClick={grantAccess} style={{ padding: '12px' }}>Grant Access</button>
    </div>
  );
};

export default FreeLicense;
